export default "__VITE_ASSET__BM$DqAXR__"